module.exports = __webpack_public_path__ + "img/i_list_info_star.bc8c35c7.svg";